import { dayjs } from "neetocommons/utils";

const getWeekString = ({
  date,
  isStartOfWeek = true,
  showMonth = false,
  showYear = false,
}) =>
  `${showMonth || isStartOfWeek ? date.format("MMM") : ""} ${date.date()} ${
    showYear || !isStartOfWeek ? date.format("YYYY") : ""
  }`;

export const getStartOfWeek = date => dayjs(date).startOf("week");

export const getEndOfWeek = date => dayjs(date).endOf("week");

export const getFormattedMonthStr = date => date.format("MMM YYYY");

export const getFormattedWeekRangeStr = date => {
  const startOfWeek = getStartOfWeek(date);
  const endOfWeek = getEndOfWeek(date);

  const shouldShowMonthsSeparately = startOfWeek.month() !== endOfWeek.month();
  const shouldShowYearsSeparately = startOfWeek.year() !== endOfWeek.year();

  const startOfWeekStr = getWeekString({
    date: startOfWeek,
    showMonth: shouldShowMonthsSeparately,
    showYear: shouldShowYearsSeparately,
  });

  const endOfWeekStr = getWeekString({
    date: endOfWeek,
    isStartOfWeek: false,
    showMonth: shouldShowMonthsSeparately,
    showYear: shouldShowYearsSeparately,
  });

  return `${startOfWeekStr} - ${endOfWeekStr}`;
};

export const getFormattedDayStr = date => date.format("DD MMM YYYY");

export const getFormattedRangeStr = (date, picker) => {
  const formatFunctions = {
    month: getFormattedMonthStr,
    week: getFormattedWeekRangeStr,
    day: getFormattedDayStr,
  };
  const selectedFormatter = formatFunctions[picker];

  return selectedFormatter(date);
};

export const mergeRefs =
  (...refs) =>
  node =>
    refs
      .filter(Boolean)
      .forEach(ref =>
        typeof ref === "function" ? ref(node) : (ref.current = node)
      );
